const cs = () => {
    const all = {
        appName: 'Templating',
        me: 'Já',
        items: '[0] žádná položka |[1] 1 položka |[2,4] {count} položky |[5,*] {count} položek ',
        existence: '[0] Neexistuje |[1] Jedna |[2,4] Mene nez pet |[5,*] Pět a vice ',
        test: '[0] žádná položka |[1] jedna položka |[2,4] pár položek ({count}) |[5,*] {count} položek',
        loginPlaceholder: 'Uživatelské jméno nebo email',
        cantLogin: 'Nemohu se přihlásit',
        pwdPlaceholder: 'Heslo',
        loading: 'Nahrávání',
        loadingExt: 'Nahrávání {ext}',
        saving: 'Ukládání',
        savingExt: 'Ukládání {ext}',
        sending: 'Odesílání',
        sendingExt: 'Odesílání {ext}',
        validating: 'Probíhá validace',
        validatingExt: 'Probíhá validace {ext}',
        search: 'Vyhledat',
        filterType: 'Typ',
        filterRole: 'Role',
        Dashboard: 'Úvod',
        Template: 'Úprava šablony',
        Templates: 'Šablony',
        TemplateVersions: 'Verze šablony',
        TemplateTools: 'Nástroje',
        TemplateFormat: 'Formátování',
        TemplateBasics: 'Základní',
        Tester: 'Testování šablony',
        Placeholders: 'Zástupky',
        Placeholder: 'Detail zástupky',
        Snippets: 'Snippety',
        Snippet: 'Upravit snippet',
        Tags: 'Tagy',
        Tag: 'Tag',
        Files: 'Soubory',
        File: 'Soubor',
        BatchImport: 'Hromadné zpracování',
        WysiwygEditor: 'Editor',
        SourceCode: 'Zdrojový kód',
        Profile: 'Profil',
        MyProfile: 'Můj profil',
        Sorry: 'Bohužel',
        Error: 'Chyba',
        NoPermission: 'Nemáte oprávnění pro {path}',
        MissingRequired: 'Chybí povinné údaje: {subject}',
        Users: 'Uživatelé',
        role: 'Role',
        userName: 'Uživatelské jméno',
        firstName: 'Jméno',
        lastName: 'Příjmení',
        email: 'Email',
        snippetName: 'Název snippetu',
        snippetType: 'Typ snippetu',
        snippetSource: 'Obsah snippetu',
        snippetPreview: 'Předběžný náhled',
        notFound: 'Nenalezeno',
        notFoundText: 'Nic nebylo nalezeno',
        password: 'Heslo',
        passwordAgain: 'Heslo znovu',
        passwordInfo: 'Heslo vyplňte pouze v případě, že ho chcete změnit.',
        passwordNotMatch: 'Hesla se neshodují!',
        passwordRulesUnmatched1: 'Délka hesla musí být 8 - 32 znaků',
        passwordRulesUnmatched2: 'Heslo musí obsahovat alespoň jedno malé písmeno',
        passwordRulesUnmatched3: 'Heslo musí obsahovat alespoň jedno velké písmeno',
        passwordRulesUnmatched4: 'Heslo musí obsahovat alespoň jedno číslo',
        passwordRulesUnmatched5: 'Heslo musí obsahovat alespoň jeden nealfanumerický znak',
        Settings: 'Nastavení klienta',
        placeholderBasic: 'Základní nastavení',
        placeholderName: 'Název skupiny',
        placeholderDescription: 'Poznámka',
        placeholderType: 'Typ zástupky',
        placeholderSimpleDescription: 'Je povolena pouze jedna hodnota',
        placeholderMultipleDescription: 'Nabývá více hodnot',
        placeholderTypeSimple: 'Základní',
        placeholderTypeMultiple: 'Iterátor',
        placeholderTypeImageCode: 'Obrázkový kód',
        imageCodeGenerateButton: 'Vygenerovat kód',
        imageCodeWidth: 'Šířka',
        imageCodeHeight: 'Výška',
        imageCodeTypeDescription: 'Vyberte typ obrázkového kódu',
        imageQrCodePayment: 'QR Platba',
        imageQrCodeURL: 'QR URL',
        imageQrCodeText: 'QR Text',
        imageCodeType: 'Typ',
        imageQrCodePaymentAccount: 'Číslo účtu',
        imageQrCodePaymentAmount: 'Částka',
        imageQrCodePaymentCurrency: 'Měna',
        imageQrCodePaymentDate: 'Datum splatnosti',
        imageQrCodePaymentVS: 'Variabilní symbol',
        imageQrCodePaymentKS: 'Konstatní symbol',
        imageQrCodePaymentSS: 'Specifický symbol',
        imageQrCodePaymentMessage: 'Zpráva',
        imageCodeURL: 'URL',
        imageCodeText: 'Text',
        imageCodeChangeButton: 'Změnit typ',
        imageCodePreviewButton: 'Náhled kódu',
        placeholderKey: 'Klíč',
        placeholderKeyDescription: 'Popis klíče',
        placeholderNewKey: 'Nový klíč',
        placeholderKeys: 'Klíče',
        placeholderKeyValue: 'Hodnota',
        placeholderKeySampleValues: 'Testovací hodnoty',
        palceholderKeyExists: 'Zadaný klíč již v této skupině existuje',
        palceholderNoKey: 'Zadejte unikátní název klíče',
        placeholderNoValue: 'Zadejte hodnotu pro klíč',
        tagName: 'Název tagu',
        tagDescription: 'Popis tagu',
        tagColor: 'Barva tagu',
        tagEnter: 'Zadejte tag',
        tagIsValid: 'Tag je aktivní',
        tagIsNotValid: 'Tag je neaktivní',
        templateVersionChangeLog: 'Poznámka k verzi',
        templateVersionSubject: 'Předmět',
        templateVersion: 'Verze šablony',
        templateVersionExpert: 'Expert',
        templateVersionCSS: 'CSS styly',
        templateVersionCSSButton: 'Upravit CSS styly',
        templateVersionState: 'Stav schválení',
        templateVersionStateApproved: 'Schváleno',
        templateVersionStateDraft: 'Draft',
        templateVersionFound: 'Počet verzí',
        templateTypeChoose: 'Vyberte typ šablony',
        templateSms: 'SMS',
        templatePdf: 'PDF',
        templateEmail: 'Email',
        templateName: 'Název',
        templateCode: 'Kód',
        templateCodeChangeWarning:
            'Změna kódu může způsobit nefunkčnost při generování nebo odeslání šablony!',
        templateSelectForClone: 'Vyberte verzi šablony pro klonování',
        templateExists: 'Šablona se stejným kódem již existuje',
        templateDescription: 'Poznámka',
        templateInsertRow: 'Vložit blok',
        templateInsertRowBefore: 'Před aktivní blok',
        templateInsertRowAfter: 'Za aktivní blok',
        templateRowColCount: 'Počet sloupců',
        templateShowBlocks: 'Zvýraznit bloky šablony',
        templateShowBlocksShow: 'Bloky jsou zvýrazněné',
        templateShowBlocksHide: 'Bloky jsou skryté',
        templateShowWideEditor: 'Zobrazit editor v tabletu',
        templateShowWideEditorShow: 'Je aktivní editor v tabletu',
        templateShowWideEditorHide: 'Je aktivní editor v telefonu',
        templateBlockDeletion: 'Vymazání celého bloku',
        templateBlockDelete: 'Vymazat blok',
        templateBlockDeleteAsk: 'Opravdu chcete vymazat tento blok({id})?',
        templatePreview: 'Náhled',
        previewEmailSend: 'Email s náhledem byl úspěšně odeslán',
        previewFileCreated: 'Soubor s náhledem byl vytvořen',
        previewEmailNotSend: 'Při odesílání náhledu došlo k chybě',
        previewFileNotCreated: 'Při vytváření náhledu došlo k chybě',
        templatePreviewDescription: 'Vyplňte požadovaná pole a pokračujte tlačítkem Odeslat',
        templatePreviewNoPlaceholders:
            'Nebyly nalezeny žádné zástupky. Pokračujte tlačítkem Odeslat.',
        templateTextColor: 'Barva textu',
        templateBackgroundColor: 'Barva pozadí',
        templateBackgroundImage: 'Obrázek na pozadí',
        templateBackgroundRepeat: 'Opakování pozadí',
        templateBackgroundRepeatNoRepeat: 'Neopakovat',
        templateBackgroundRepeatRepeatX: 'Opakovat horizontálně',
        templateBackgroundRepeatRepeatY: 'Opakovat vertikálně',
        templateBackgroundRepeatRepeat: 'Opakovat',
        templateBackgroundSize: 'Přizpůsobení pozadí obsahu',
        templateBackgroundSizeAuto: 'Automaticky',
        templateBackgroundSizeXAuto: 'Automaticky na šířku',
        templateBackgroundSizeCover: 'Pokrýt',
        templateBackgroundSizeContain: 'Celé viditelné',
        templateBackgroundPositionX: 'Horizontální pozice pozadí',
        templateBackgroundPositionY: 'Vertikální pozice pozadí',
        templateBackgroundPositionXLeft: 'Vlevo',
        templateBackgroundPositionXCenter: 'Uprostřed',
        templateBackgroundPositionXRight: 'Vpravo',
        templateBackgroundPositionYTop: 'Nahoře',
        templateBackgroundPositionYCenter: 'Uprostřed',
        templateBackgroundPositionYBottom: 'Dole',
        templateFontSize: 'Velikost písma',
        templateFontStyle: 'Styl písma',
        templateFontStyleNormal: 'Normální',
        templateFontStyleItalic: 'Kurzíva',
        templateFontWeight: 'Tloušťka písma',
        templateFontWeightNormal: 'Normální',
        templateFontWeightBold: 'Tučné',
        templateTextAlign: 'Zarovnání textu v bloku',
        templateTextAlignLeft: 'Doleva',
        templateTextAlignRight: 'Doprava',
        templateTextAlignCenter: 'Na střed',
        templateTextAlignJustify: 'Do bloku',
        templateContentWidth: 'Šířka',
        templateContentHeight: 'Výška',
        templatePadding: 'Odsazení bloku',
        templatePaddingAdvanced: 'Podrobné',
        templatePaddingAdvancedTop: 'Horní',
        templatePaddingAdvancedRight: 'Zprava',
        templatePaddingAdvancedBottom: 'Dolní',
        templatePaddingAdvancedLeft: 'Zleva',
        templateSchemaDescription: 'Datové schéma šablony, které se odesílá ke zpracování',
        templateFooter: 'Patička',
        templateFooterDescription: 'Patička šablony, která se přidá na konec každé stránky',
        templateHeader: 'Hlavička',
        templateHeaderDescription: 'Hlavička šablony, která se přidá na začátek každé stránky',
        templateMeta: 'Metadata',
        templateMetaOrigin: 'Origin',
        templateMetaAuthor: 'Autor',
        templateMetaKeywords: 'Klíčová slova',
        latest: 'Nejnovější',
        version: 'Verze',
        versionCount: 'Počet verzí',
        created: 'Vytvořeno',
        updated: 'Poslední změna',
        Login: 'Přihlášení',
        Logout: 'Odhlásit',
        UITest: 'UI test',
        language: 'Jazyk',
        templateLanguage: 'Jazyk šablony',
        cs: 'Čeština',
        en: 'English',
        copyToClipboard: 'Zkopírovat do schránky',
        copiedToClipboard: 'Zkopírováno do schránky',
        footerDenial: 'Publikování nebo šíření obsahu je zakázáno.',
        labelSelectVariable: 'Vyberte zástupku',
        labelValidJSON: 'Validní JSON',
        labelInvalidJSON: 'Nevalidní JSON',
        labelValidCSV: 'Validní CSV',
        labelInvalidCSV: 'Nevalidní CSV',
        labelValidDataset: 'Validní dataset',
        labelInvalidDataset: 'Nevalidní dataset',
        labelJSON: 'JSON',
        labelCSV: 'CSV',
        labelAPI: 'API',
        buttonOk: 'Ok',
        buttonChoose: 'Vybrat',
        buttonUse: 'Použít',
        buttonCancel: 'Zrušit',
        buttonClose: 'Zavřít',
        buttonInsert: 'Vložit',
        buttonInsertPlaceholder: 'Vložit zástupku',
        buttonInsertImagePlaceholderData: 'Vložit data zástupky',
        buttonInsertAsCondition: 'Vložit jako podmínku',
        buttonInsertAsImageCode: 'Vložit QR nebo čárový kód',
        buttonInsertImageCode: 'Vložit kód',
        buttonInsertAsTable: 'Vložit jako tabulku',
        buttonInsertIteratorStart: 'Začátek cyklu',
        buttonInsertIteratorEnd: 'Konec cyklu',
        buttonInsertAsList: 'Vložit jako seznam',
        buttonInsertAsWidgetType: 'Element type',
        buttonRemoveCondition: 'Odstranit podmínku',
        buttonInsertConditionValue: 'Vložit hodnotu podmínky',
        buttonRemoveConditionValue: 'Odstranit hodnotu podmínky',
        buttonConditionUseElse: 'Použít else',
        buttonPreview: 'Vytvořit náhled',
        buttonValidate: 'Validace',
        buttonYes: 'Ano',
        buttonNo: 'Ne',
        buttonBack: 'Zpět',
        buttonSave: 'Uložit',
        buttonSaveAs: 'Uložit jako...',
        buttonActivate: 'Aktivovat',
        buttonDectivate: 'Deaktivovat',
        buttonSend: 'Odeslat',
        buttonAdd: 'Přidat',
        buttonAddRow: 'Přidat řádek',
        buttonRemove: 'Odebrat',
        buttonReset: 'Vymazat',
        buttonNewUser: 'Nový uživatel',
        buttonNewSnippet: 'Nový snippet',
        buttonFormatSnippet: 'Formatovat snippet',
        buttonNewTemplate: 'Nová šablona',
        buttonEditTemplate: 'Upravit šablonu',
        buttonNewTemplateVersion: 'Nová verze',
        buttonNewPlaceholder: 'Nová skupina',
        buttonNewFile: 'Nový soubor',
        buttonNewTag: 'Nový tag',
        buttonAddTag: 'Přidat tag',
        buttonRemoveTag: 'Odstranit tag',
        buttonSaveAndClose: 'Uložit a zavřít',
        buttonSaveCopy: 'Uložit kopii',
        buttonSetRole: 'Nastavit roli',
        buttonLogin: 'Přihlásit',
        buttonSendByEmail: 'Odeslat emailem',
        buttonNoEmailSend: 'Neposílat emailem',
        buttonSchema: 'Schéma',
        buttonExportDuid: 'Exportovat duid',
        buttonExportRecipient: 'Exportovat příjemce',
        buttonDownloadCSVFile: 'Stáhnout CSV soubor',
        buttonDownloadJSONFile: 'Stáhnout JSON soubor',
        buttonContinue: 'Pokračovat',
        buttonImportJSON: 'Importovat JSON',
        buttonExportJSON: 'Exportovat JSON',
        buttonImport: 'Import',
        buttonExport: 'Export',
        buttonImportFromAnother: 'Importovat z jiné šablony',
        processFiles: 'Zpracovat soubory',
        editorToggleBold: 'Tučné písmo',
        editorToggleItalic: 'Kurzíva',
        editorToggleStrike: 'Přeškrtnuté',
        editorToggleUnderline: 'Podtržení',
        editorToggleSuperscript: 'Horní index',
        editorToggleSubscript: 'Dolní index',
        editorToggleTextAlignLeft: 'Zarovnat doleva',
        editorToggleTextAlignCenter: 'Zarovnat na střed',
        editorToggleTextAlignRight: 'Zarovnat doprava',
        editorToggleTextAlignJustify: 'Zarovnat do bloku',
        editorToggleParagraph: 'Odstavec',
        editorToggleDiv: 'Blok (div)',
        editorToggleHeader: 'Styl nadpisu',
        editorToggleHeader1: 'Nadpis 1',
        editorToggleHeader2: 'Nadpis 2',
        editorToggleHeader3: 'Nadpis 3',
        editorToggleHeader4: 'Nadpis 4',
        editorToggleHeader5: 'Nadpis 5',
        editorToggleHeader6: 'Nadpis 6',
        editorInsertImage: 'Vložit obrázek',
        editorInsertImageUrl: 'URL',
        editorInsertImageCannotUse: 'Tento zdroj obrázku nelze použít, špatný formát {format}',
        editorInsertImageWidth: 'Šířka obrázku',
        editorInsertImageHeight: 'Výška obrázku',
        editorInsertImageAlt: 'Popisek obrázku',
        editorEditImage: 'Upravit obrázek',
        editorInsertLink: 'Vložit/upravit odkaz',
        editorRemoveLink: 'Odstranit odkaz',
        editorInsertProtocolAndAddress: 'Zadejte protokol a adresu odkazu',
        editorLinkInvalid: 'Tento odkaz nelze použít',
        editorLinkValid: 'Tento odkaz lze použít',
        editorToggleBlockqoute: 'Bloková citace',
        editorToggleHighlight: 'Zvýraznění',
        editorToggleClearFormatting: 'Odstranit formátování',
        editorToggleBulletList: 'Bodový (neuspořádaný) seznam',
        editorToggleOrderedList: 'Číselný (uspořádaný) seznam',
        editorLiftListItem: 'Odebrat odsazení',
        editorSinkListItem: 'Přidat odsazení',
        editorSetHorizontalRule: 'Vložit vodorovnou čáru',
        editorSetPageBreak: 'Vložit konec stránky',
        editorPageBreak: 'Konec stránky',
        editorUndo: 'Zpět',
        editorRedo: 'Vpřed',
        editorInsertTable: 'Vložit tabulku',
        editorAddColumnBefore: 'Přidat sloupec před',
        editorAddColumnAfter: 'Přidat sloupec za',
        editorDeleteColumn: 'Odebrat sloupec',
        editorAddRowBefore: 'Přidat řádek před',
        editorAddRowAfter: 'Přidat řádek za',
        editorDeleteRow: 'Odebrat řádek',
        editorDeleteTable: 'Smazat tabulku',
        editorMergeCells: 'Sloučit buňky',
        editorSplitCell: 'Rozdělit buňku',
        editorToggleHeaderColumn: 'Nastavit/zrušit první sloupec jako hlavičku',
        editorToggleHeaderRow: 'Nastavit/zrušit první řádek jako hlavičku',
        editorToggleHeaderCell: 'Nastavit/zrušit buňku jako hlavičku',
        editorInsertVariable: 'Vložit zástupku',
        editorVariables: 'Zástupky',
        imageEditorPreview: 'Uložit obrázek',
        imageEditorPreviewText: 'Náhled obrázku pro uložení',
        imageEditorOpenFile: 'Otevřít soubor',
        imageEditorRotateLeft: 'Otočit doleva',
        imageEditorRotateRight: 'Otočit doprava',
        imageEditorFlipH: 'Otočit vodorovně',
        imageEditorFlipV: 'Otočit svisle',
        imageEditorZoomIn: 'Přiblížit',
        imageEditorZoomOut: 'Oddálit',
        imageEditorMoveLeft: 'Posunout doleva',
        imageEditorMoveRight: 'Posunout doprava',
        imageEditorMoveUp: 'Posunout nahoru',
        imageEditorMoveDown: 'Posunout dolů',
        imageEditorCrop: 'Oříznout a uložit',
        imageEditorRevert: 'Vrátit všechny změny',
        imageListPreview: 'Obsah adresáře',
        imageListPreviewText:
            '[0] žádný soubor |[1] jeden soubor |[2,4] {count} soubory |[5,*] {count} souborů',
        imageEditorFilename: 'Název souboru',
        multipleUploadFilesSentTitle: 'Odeslání dokončeno',
        multipleUploadFilesSent: 'Soubory byly úspěšně odeslány ke zpracování',
        welcomeText: 'Vítejte v aplikaci',
        backendServerNote: 'Backendový server',
        fileServerNote: 'Souborový server',
        templateStatsNote: 'Druhy šablon',
        placeholderStatsNote: 'Skupiny zástupek (počet zástupek)',
        placeholderSimpleStatsNote: 'Základní zástupky',
        placeholderMultipleStatsNote: 'Iterativní zástupky',
        placeholderImageCodeStatsNote: 'Obrázkové kódy',
        serverOk: '{serverName} je dostupný',
        serverFail: '{serverName} je nedostupný',
        notifyOk: 'Hotovo',
        notifyError: 'Chyba',
        notifyMessageSaved: 'Požadavek byl uložen',
        paginatorPage: 'Stránka',
        paginatorPrev: 'Předchozí',
        paginatorNext: 'Další',
        orderBy: 'Řazení',
        error404: 'Chyba 404 - nenalezeno',
        error404Text: 'Požadovaná stránka nebyla na serveru nalezena',
        backHome: 'Zpět na úvod',
        filterAll: 'Nerozlišovat',
        sortName: 'Název',
        sortCode: 'Kód',
        sortUserName: 'Uživatelské jméno',
        sortLastName: 'Příjmení',
        sortEmail: 'E-mail',
        sortType: 'Typ',
        sortVersion: 'Verze',
        sortLangCode: 'Jazyk',
        sortSubject: 'Předmět',
        sortState: 'Stav',
        sortCreated: 'Datum vytvoření',
        sortUpdated: 'Datum aktualizace',
        validationCompliant: 'Vyhovující',
        validationNonCompliant: 'Nevyhovující',
        validationPassedChecks: 'Úspěšné testy',
        validationFailedChecks: 'Neúspěšné testy',
        validationTotalChecks: 'Celkem',
        validationResultClause: 'Klauzule',
        validationResultContext: 'Kontext',
        validationResultDescription: 'Zpráva',
        validationResultRuleId: 'ID pravidla',
        validationResultTestNumber: 'Číslo testu',
        templateValidationDescription:
            'Výsledky validace šablony pro nevidomé. Níže naleznete seznam nalezených chyb, varování a informací. Upozornění: i když se šablona může zdát funkční, doporučuje se opravit všechny chyby a varování pro zajištění správné funkčnosti.',
        isPdfUaStrict: 'Přístupnost pro nevidomé (PDF/UA)',
        isPdfUaStrictOn: 'Přístupnost je požadována',
        isPdfUaStrictOff: 'Přístupnost není požadována',
    };

    return {
        all,
    };
};

export default cs;
